export const operationType = {
	INCREMENT: 'increment',
	DECREMENT: 'decrement',
};

export const defaultRoom = { adults: 2, children: 0 };
